<template lang="pug">
  div(@click="onClick()" class="cursor-pointer color-link")
    | {{name}}
</template>

<script>
import ELink from '~/components/elements/links/e-link'
import contentDialog from '~/mixins/dialogs/contentDialog'
export default {
  components: { ELink },
  mixins: [contentDialog],
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  computed: {
    name () {
      return this._.get(this.value, 'profile.name', '')
    },
    modalFields () {
      return [
        {
          label: 'Name',
          val: this.name
        },
        {
          label: 'Email',
          val: this._.get(this.value, 'profile.email'),
          value: val => val || '-'
        },
        {
          label: 'Phone',
          val: this._.get(this.value, 'profile.phone'),
          value: val => val || '-'
        }
      ]
    }
  },
  methods: {
    onClick () {
      this.contentDialog.open({
        component: 't-orm-simple-data',
        title: this.$t('Owner card'),
        componentProps: {
          items: this.modalFields
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
